import { styled, Breakpoint } from '@mui/system'

type StyleProps = {
  switchOn: number | Breakpoint
}

export const StatLabel = styled('span')<StyleProps>(({ switchOn, theme }) => ({
  '&>.lg': {
    display: 'inline',
    textAlign: 'center',
  },
  '&> .sh': {
    display: 'none',
  },

  [theme.breakpoints.down(switchOn)]: {
    '&>.lg': {
      display: 'none',
    },
    '&>.sh': {
      display: 'inline',
      textAlign: 'center',
    },
  },
}))

export type ResponsiveLabelProps = {
  short: string
  long: string
  switchOn?: Breakpoint | number
}

export const ResponsiveLabel: React.FC<
  React.PropsWithChildren<ResponsiveLabelProps>
> = ({ short, long, switchOn }) => {
  return (
    <StatLabel switchOn={switchOn || 'md'}>
      <span className="lg">{long}</span>
      <span className="sh">{short}</span>
    </StatLabel>
  )
}
